import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../utils/constants';

export const test = {
  padding: '96px 0 96px',

  [MediaQueries.md]: {
    padding: '64px 0 96px',
  },

  [MediaQueries.lgAndUp]: {
    padding: '64px 0 96px',
  },
};

export const itemsContainerCss = css({
  paddingBottom: '0px',
  paddingTop: '0px',
  margin: '128px 0px 0px 0px',

  [MediaQueries.xl]: {
    maxWidth: '1530px',
    width: '100%',
    margin: '128px auto',
  },

  [MediaQueries.sm]: {
    paddingBottom: '40px',
    paddingTop: '0px',
    width: '100%',
    margin: '64px 0px 0px 0px',
  },
  [MediaQueries.lg]: {
    paddingBottom: '50px',
    paddingTop: '0px',
    width: '100%',
    margin: '96px 0px 0px 0px',
  },
  [MediaQueries.md]: {
    paddingBottom: '50px',
    width: '100%',
    margin: '96px 0px 0px 0px',
  },
});
